import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class SenderAddressPriorityProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'priority/sender-address'
}
